import styled from "styled-components";
import { COLORS, HELPERS } from "../../../shared";

export const ModalHeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  border-bottom: 1px solid ${COLORS.GRAY_THREE};
  .modal-header {
    &__close {
      width: 25px;
      height: 25px;
      cursor: pointer;
      transition: ${HELPERS.TRANSITION};
      svg {
        transition: ${HELPERS.TRANSITION};
        fill: ${COLORS.GRAY_TWO};
        transition-delay: 0ms;
        path {
          fill: inherit;
          transition: ${HELPERS.TRANSITION};
        }
      }
      &:hover {
        svg {
          fill: ${COLORS.PRIMARY_DARK};
        }
      }
    }
  }
`;
